import { REORDERED_SUMMARY, UNCHANGED_SUMMARY } from './constants';
import type { DisplayChange } from './types';

export function getStatusBodyText(change: DisplayChange): string | undefined {
  if (change.isUnchanged) {
    return UNCHANGED_SUMMARY;
  }
  if (change.isReordered) {
    return REORDERED_SUMMARY;
  }

  return undefined;
}
